import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export const PrivacyPolicy = () => {
  const { t } = useLang();
  const p = t.privacy;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, []);

  return (
    <section
      id="privacy"
      data-testid="privacy-page"
      className="relative pt-32 sm:pt-40 pb-24 min-h-screen"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 right-1/4 w-[520px] h-[520px] rounded-full bg-[#FF5A00]/10 blur-[140px]" />
      </div>

      <div className="relative max-w-3xl mx-auto px-6 lg:px-8">
        <Link
          to="/"
          data-testid="privacy-back"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-[#FF5A00] transition-colors"
        >
          <i className="fa-solid fa-arrow-left text-xs" />
          {p.back}
        </Link>

        <div className="mt-8">
          <div className="eyebrow">{p.lastUpdated}</div>
          <h1
            data-testid="privacy-title"
            className="mt-4 font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-[1.05] tracking-tight"
          >
            {p.title}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed">
            {p.intro}
          </p>
        </div>

        <div className="mt-14 space-y-10">
          {p.sections.map((s, i) => (
            <div key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="font-[Outfit] text-xl sm:text-2xl font-semibold text-white">
                {s.title}
              </h2>
              <p className="mt-3 text-sm sm:text-base text-zinc-400 leading-relaxed">
                {s.body}
              </p>
              {s.list && (
                <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
                  {s.list.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-2 text-sm text-zinc-300"
                    >
                      <span className="mt-1.5 w-1 h-1 rounded-full bg-[#FF5A00] shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              )}
              {s.email && (
                <a
                  href={`mailto:${s.email}`}
                  data-testid="privacy-contact-email"
                  className="mt-3 inline-flex items-center gap-2 text-[#FF5A00] hover:underline"
                >
                  <i className="fa-solid fa-envelope text-xs" />
                  {s.email}
                </a>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 text-xs text-zinc-500 leading-relaxed">
          {p.disclaimer}
        </div>
      </div>
    </section>
  );
};
